module.exports = __webpack_public_path__ + "static/media/login1.7504f6d1.png";